class Toast {
    containerHtml = '<div class="toast-container position-fixed bottom-0 end-0 p-3 pb-5"></div>';

    constructor() {
        this.$body = $('body');
    }

    /**
     * @param {Object} $form
     * @param {string} toast toast HTML
     * @param {Object} response JSON Object
     */
    displayHtml($form, toast, response){
        let instance = this;
        let $toast = $(toast);
        let $toastContainer = this.$body.find('.toast-container');
        if(!$toastContainer.length) {
            $toastContainer = $(this.containerHtml);
            this.$body.append($toastContainer);
        }
        $toastContainer.append($toast);
        let bsToast = new bootstrap.Toast($toast[0], {});

        let redirect = null;
        //padarom redirecta tik poto kai uzdaromas modal'as
        if(typeof response.redirect === 'string') {
            redirect = response.redirect
            delete response.redirect;
        }

        let callback = null
        let callbacks = null
        //padarom callback tik poto kai uzdaromas toast'as
        if(typeof response.callback === 'string') {
            callback = response.callback
            delete response.callback;
        }

        if(typeof response.callbacks == "object" && Array.isArray(response.callbacks)){
            callbacks = response.callbacks
            delete response.callbacks;
        }

        let evalCallback = function(evalValue, nonce) {
            let $script = $('<script nonce="' + nonce + '">' + evalValue + '</script>');
            instance.$body.append($script);
            $script.remove();
        }

        $toast.on('hidden.bs.toast', function (event) {
            bsToast.dispose()
            $toast.remove();
            if(!$toastContainer.find('.toast').length) {
                $toastContainer.remove();
            }

            if(redirect){
                window.location.href = redirect;
            }
            if(callback){
                evalCallback(callback, response.nonce);
            }

            if(callbacks){
                callbacks.forEach((callback) => {
                    evalCallback(callback, response.nonce);
                })
            }
        });
        bsToast.show();
    };

    /**
     * @param {Object} $form
     * @param {Object} response JSON Object
     */
    show($form, response){
        if ($form.data('ignore_messages') || $form.data('ignore_toasts')) {
            return;
        }

        let instance = this;
        let toastBody = '';
        if(typeof response.toasts == "object"){
            if(Array.isArray(response.toasts )){
                $.each(response.toasts, function (index, msg) {
                    if(toastBody !== '') {
                        toastBody += '<hr class="opacity-100">';
                    }
                    if(typeof msg == "object"){
                        toastBody += '<p><img src="/Project/Modules/General/Admin/assets/images/icons/icon-'+ msg.type +'.svg" alt="'+ msg.type +'"/></p>'
                            + '<p class="mb-0">'+msg.text+'</p>';
                    }else{
                        toastBody += '<p><img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg" alt="info"/></p>'
                            + '<p class="mb-0">'+msg+'</p>';
                    }
                })
            }else{
                toastBody += '<p><img src="/Project/Modules/General/Admin/assets/images/icons/icon-'+ response.toasts.type +'.svg" alt="'+ response.toasts.type +'"/></p>'
                    +'<p class="mb-0">'+response.toasts.text+'</p>';
            }
        }else{
            toastBody += '<p><img src="/Project/Modules/General/Admin/assets/images/icons/icon-info.svg" alt="info"/></p>'
                + '<p class="mb-0">'+(response.toasts || '')+'</p>';
        }
        if(toastBody){
            instance.displayHtml($form, instance.getHtml(toastBody), response);
        }
    }

    /**
     * @param {string} toastBody
     */
    getHtml(toastBody) {
        return ''
            + '<div class="toast align-items-center" role="alert" aria-live="assertive" aria-atomic="true" data-bs-delay="3000">'
                + '<div class="d-flex">'
                    + '<div class="toast-body flex-grow-1 text-center">' + toastBody + '</div>'
                    + '<button type="button" class="btn-close btn-close me-2 mt-2 ms-auto" data-bs-dismiss="toast" aria-label="Uždaryti"></button>'
                + '</div>'
            + '</div>';
    }
}

if (typeof module === 'object' && typeof module.exports === 'object') {
    module.exports = new Toast();
} else {
    var systemsightToast;
    $(document).ready(function () {
        systemsightToast = new Toast();
    });
}
